import { NImage, NLayoutHeader, NMenu, NSpace, NText } from 'naive-ui';
import { defineComponent } from 'vue';

import logo from '@/assets/logo.svg';

import { SuperChatButton } from '@/features/SuperChat/SuperChatButton';
import { Icons } from '@/utils';
import { AppUserMenu } from '..';
import { RenderIcon } from '../..';
import { AppButtonIcon } from '../AppButtonIcon';
import { AppSupportButton } from '../AppSupportButton';
import { AppUserNotification } from '../AppUserNotification';
import { AppHeaderSearchBar } from './AppHeaderSearchBar';
import { AppMenu } from './AppMenu';

export const AppHeader = defineComponent({
	extends: AppMenu,

	render() {
		return (
			<NLayoutHeader bordered class="app-header">
				<NSpace align="center" justify="space-between" class="app-header__inner">
					<div class="app-header__brand">
						<NImage src={logo} preview-disabled height="32" class="m0" />

						{process.env.NODE_ENV === 'development' && (
							<NText style="color: var(--alm-text-soft); font-size:10px; font-weight: 600; letter-spacing: 0.04em;">
								DEV
							</NText>
						)}
						{import.meta.env.VITE_APP_RELEASE_VERSION && (
							<NText style="font-size:10px; font-weight: bold; color: #a1a4a4">
								{import.meta.env.VITE_APP_RELEASE_VERSION}
							</NText>
						)}
					</div>
					<NSpace align="center">
						<NMenu
							//theme-overrides={headerMenuTheme}
							class="app-header-menu"
							v-model:value={this.activeKey}
							expandIcon={RenderIcon(Icons.ChevronDown)}
							collapsedIconSize={22}
							mode="horizontal"
							options={this.menuOptions}
						/>

						<AppHeaderSearchBar onSearch={this.handleSearch} />
					</NSpace>

					<NSpace align="center" class="app-header__actions">
						<SuperChatButton />
						<AppSupportButton />
						<AppUserNotification />

						<AppButtonIcon
							icon={this.currentTheme == 'light' ? Icons.LightMode : Icons.DarkMode}
							onClick={this.toggleTheme}
							tooltipMessage="Mudar tema"
						/>

						<AppUserMenu />
					</NSpace>
				</NSpace>
			</NLayoutHeader>
		);
	},
});

export default AppHeader;
